import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';

export const ExploreKeyframesRecording20261027Composition = () => {
	const {fps} = useVideoConfig();
	const frame = (useCurrentFrame() * 60) / fps;

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={(636 / 60) * fps}
			style={{
				width: 2194,
				height: 1438,
			}}
		>
			<Video
				src={
					'https://remotion.media/explore-remotion/keyframes-source-2026-10-27-2af58b0a819c.mp4'
				}
				durationInFrames={(636 / 60) * fps}
				muted
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[5, 25, 38, 118, 255, 258, 273, 318, 501, 502, 503],
					[
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[
							0, 60, 64, 109, 149, 186, 248, 285, 290, 314, 356, 393, 456, 540,
							547,
						],
						[
							4.5195669920672294, 4.067610292860507, 4.5195669920672294,
							4.067610292860507, 4.5195669920672294, 4.067610292860507,
							4.5195669920672294, 4.067610292860507, 4.5195669920672294,
							4.067610292860507, 4.5195669920672294, 4.067610292860507,
							4.5195669920672294, 4.067610292860507, 4.5195669920672294,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 23, 24,
							25, 26, 27, 28, 30, 31, 32, 33, 37, 38, 39, 40, 41, 42, 70, 71,
							72, 73, 74, 75, 76, 77, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91,
							92, 93, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 109,
							110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122,
							123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135,
							136, 137, 138, 139, 140, 141, 149, 150, 151, 152, 153, 154, 155,
							156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168,
							169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 196, 197, 198,
							199, 200, 201, 202, 206, 207, 208, 209, 210, 213, 214, 215, 216,
							217, 218, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 250,
							251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263,
							268, 269, 270, 271, 272, 273, 274, 275, 276, 295, 296, 297, 298,
							299, 300, 301, 302, 311, 312, 313, 314, 315, 316, 317, 318, 319,
							320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332,
							333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345,
							346, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370,
							371, 372, 373, 398, 399, 400, 401, 402, 403, 407, 408, 409, 412,
							413, 414, 418, 419, 420, 421, 422, 423, 424, 425, 426, 427, 448,
							449, 450, 497, 498, 499, 500, 501, 502, 503, 504, 505, 506, 507,
							508, 509, 510, 511, 512, 513, 514, 515, 516, 517, 518, 519, 520,
							521, 522, 523, 524, 525, 526, 527, 528, 529, 530, 531,
						],
						[
							'1930.5612879552175px 2039.5605325217139px',
							'1930.5612879552175px 2039.5605325217139px',
							'1889.6380212067338px 1844.4657987466526px',
							'1834.061470851157px 1616.8397822949257px',
							'1803.6132881586586px 1455.1005783994292px',
							'1766.1503148884765px 1329.1410959561463px',
							'1721.7550309313956px 1196.8025249696777px',
							'1699.6162144936914px 1126.4433161950403px',
							'1688.011238689689px 1089.8865183135872px',
							'1681.6791829939245px 1063.098760071848px',
							'1680.4903967419523px 1056.4840935128404px',
							'1680.4786730116566px 1056.4369227391805px',
							'1680.4786730116566px 1056.4369227391805px',
							'1680.6080478236245px 1056.4606460522493px',
							'1682.385365336435px 1056.8843554577556px',
							'1683.9036573728326px 1057.260894089602px',
							'1683.9036573728326px 1057.260894089602px',
							'1683.0209294446945px 1055.059867171285px',
							'1677.7362856061613px 1049.198553728448px',
							'1658.422198538499px 1034.4158953093872px',
							'1629.351071413896px 1011.9474351610187px',
							'1614.1209802762603px 999.6717240578703px',
							'1614.1209802762603px 999.6717240578703px',
							'1613.815059878665px 998.4712140756025px',
							'1613.720856257584px 998.094675443756px',
							'1613.4619687074098px 997.3413223275857px',
							'1613.4619687074098px 997.3413223275857px',
							'1614.0503620420093px 995.8583394083136px',
							'1617.0046041502578px 989.4086326308768px',
							'1620.1707009612596px 980.8638262864997px',
							'1621.3476255566975px 974.2019889538323px',
							'1621.453552908074px 973.366431799354px',
							'1621.453552908074px 973.366431799354px',
							'1622.3245571059165px 972.81334758188px',
							'1626.361520188522px 970.2004729145912px',
							'1627.6562337918708px 969.129337744291px',
							'1628.9155003518554px 968.1406824647763px',
							'1629.5276169995236px 967.7641438329299px',
							'1629.786504549698px 967.4932566999825px',
							'1629.857122783949px 967.4226384657314px',
							'1629.857122783949px 967.4226384657314px',
							'1630.1042866038276px 967.4226384657314px',
							'1631.3990002071766px 966.857692591723px',
							'1634.3413806588908px 965.9868263201192px',
							'1639.9908393989747px 964.5625999785639px',
							'1642.1093864265063px 964.0213774176242px',
							'1647.288102913663px 962.4912237246922px',
							'1649.2888609332836px 961.1613389304566px',
							'1651.336789726564px 960.1489603378732px',
							'1652.6079179430828px 959.7605600494925px',
							'1653.8084279253508px 959.2427849491439px',
							'1654.1733807531402px 959.054377706982px',
							'1654.1733807531402px 959.054377706982px',
							'1655.138450645825px 959.643046894059px',
							'1656.6097098348016px 961.4319502109265px',
							'1657.2805830601865px 963.4445698870815px',
							'1658.2926858002925px 966.6930086626297px',
							'1659.163689998135px 970.6123206635631px',
							'1659.4344392048436px 972.9661698544389px',
							'1659.7992541063945px 976.1558520522705px',
							'1660.2818580158562px 978.3097081969275px',
							'1660.434818214654px 978.7921741801506px',
							'1660.4465419449496px 978.8393449538104px',
							'1660.4465419449496px 978.8393449538104px',
							'1660.1406215473542px 978.8393449538104px',
							'1657.751325313114px 977.1326456752508px',
							'1655.691672789538px 975.9086882323918px',
							'1653.6907768436786px 974.3316396182776px',
							'1646.9937683201244px 969.8473817433359px',
							'1634.023598604761px 962.8208674353564px',
							'1620.1588393047252px 955.9354516696401px',
							'1613.8974018432116px 952.3809545702577px',
							'1608.3421467242085px 948.6734972720775px',
							'1608.3421467242085px 948.6734972720775px',
							'1601.65686193095px 943.2830640084065px',
							'1601.65686193095px 943.2830640084065px',
							'1601.4332834979011px 943.1182421530744px',
							'1591.7350000186773px 937.3039615576585px',
							'1588.6866922155866px 935.5856764750421px',
							'1588.6866922155866px 935.5856764750421px',
							'1584.8144130620744px 933.2199656276318px',
							'1582.5075967186197px 931.4662335016511px',
							'1582.5075967186197px 931.4662335016511px',
							'1578.2116081596012px 929.1358317713665px',
							'1573.1036478329345px 927.111488364916px',
							'1572.6210439234726px 926.9349427792883px',
							'1572.6210439234726px 926.9349427792883px',
							'1572.5268403023917px 926.8407391582074px',
							'1571.867828733541px 926.181589663118px',
							'1570.7496607158198px 924.9576322202589px',
							'1569.9492747522283px 923.8394642025377px',
							'1569.09013221092px 922.4741323649378px',
							'1569.09013221092px 922.4741323649378px',
							'1568.8665537778713px 922.0269754988403px',
							'1568.2662987867375px 921.4267205077064px',
							'1568.2662987867375px 921.1912804181233px',
							'1568.2662987867375px 921.1912804181233px',
							'1568.2662987867375px 921.2618986523744px',
							'1568.807659273916px 922.3917904003912px',
							'1571.3028828595327px 923.3687219496103px',
							'1575.1515766262148px 923.7924313551166px',
							'1581.8720326103603px 924.2984827251695px',
							'1591.6173489370053px 924.863428599178px',
							'1602.0335384890352px 925.00466506768px',
							'1608.648067121804px 925.00466506768px',
							'1614.509380564641px 925.3577562389353px',
							'1616.686822096128px 925.3813416257652px',
							'1617.9226411955215px 925.3813416257652px',
							'1619.9116754848465px 925.3813416257652px',
							'1620.947501538021px 925.3813416257652px',
							'1621.9831896649569px 925.3813416257652px',
							'1623.2190087643503px 925.3813416257652px',
							'1624.713715413918px 925.3813416257652px',
							'1626.432138422773px 925.1223161493522px',
							'1626.796953324324px 925.0635595716356px',
							'1628.327107017256px 924.6868830135503px',
							'1629.4334133784428px 924.6868830135503px',
							'1629.8218136668236px 924.6868830135503px',
							'1630.9517054148403px 924.5692319318781px',
							'1633.9176712533845px 924.3808246897162px',
							'1640.579370659813px 924.0749042921208px',
							'1645.5696799048078px 923.8864970499588px',
							'1646.4641315632414px 923.8864970499588px',
							'1651.0425930592642px 924.3102064554652px',
							'1656.2919277806718px 924.7457775175058px',
							'1659.1754137284306px 925.0282504545099px',
							'1659.1754137284306px 925.0282504545099px',
							'1658.7399805926286px 925.0282504545099px',
							'1657.5158852235309px 924.8751523294735px',
							'1654.0202826281038px 924.6398501661292px',
							'1650.5718508063367px 924.4867520410927px',
							'1646.016974697144px 924.3808246897162px',
							'1642.8038450387212px 924.3808246897162px',
							'1642.8038450387212px 924.3808246897162px',
							'1622.6070300429208px 924.098351752712px',
							'1621.5124474120296px 924.098351752712px',
							'1619.6880970517977px 924.098351752712px',
							'1618.4286925655745px 924.098351752712px',
							'1618.4286925655745px 924.098351752712px',
							'1611.1197053205908px 924.4279954633761px',
							'1604.6346894260284px 924.4279954633761px',
							'1600.8213047764716px 924.6162647792993px',
							'1596.6782764162508px 924.7928103649269px',
							'1592.7119315678965px 924.7928103649269px',
							'1592.7119315678965px 924.7928103649269px',
							'1586.0620938180023px 925.00466506768px',
							'1583.767001204843px 925.0752833019311px',
							'1581.9779599617368px 925.3224471218098px',
							'1581.5425268259348px 925.3224471218098px',
							'1580.2360894922906px 925.3224471218098px',
							'1578.5646993308565px 925.3224471218098px',
							'1577.976305996257px 925.3224471218098px',
							'1577.3407418879974px 925.3224471218098px',
							'1577.2229528800865px 925.3224471218098px',
							'1577.2229528800865px 925.3224471218098px',
							'1577.2229528800865px 926.0169057340247px',
							'1577.399498465714px 929.8302903835814px',
							'1577.6585239421272px 938.2808931068776px',
							'1577.6585239421272px 949.2856139197459px',
							'1578.1409899253501px 963.4327082305471px',
							'1578.2469172767267px 977.4269802687894px',
							'1577.8350695277547px 986.3248777844218px',
							'1577.7761750237994px 998.3534250676915px',
							'1577.4583929696696px 1003.2967014652651px',
							'1577.0346835641633px 1007.9459191217776px',
							'1576.7404868968636px 1008.8639561670412px',
							'1576.610974158657px 1009.5111060793575px',
							'1576.469737690155px 1009.8995063677382px',
							'1576.469737690155px 1009.8995063677382px',
							'1576.469737690155px 1009.7819932123049px',
							'1576.469737690155px 1009.0167784396001px',
							'1576.469737690155px 1005.9567469062138px',
							'1576.469737690155px 999.8248221829068px',
							'1576.469737690155px 991.8212383994694px',
							'1576.2108501399807px 986.5014233700495px',
							'1576.1755410228552px 986.0658523080087px',
							'1575.963686320102px 985.4302881997493px',
							'1575.963686320102px 985.4302881997493px',
							'1576.3285012216527px 985.2421568100649px',
							'1577.7055567895484px 984.9831313336518px',
							'1580.942271834801px 984.7594149743643px',
							'1585.520595404585px 984.3241197648011px',
							'1594.2655327214195px 983.7473122342584px',
							'1601.4685926150269px 983.2764320550923px',
							'1604.622827769494px 983.2058138208412px',
							'1604.622827769494px 983.2058138208412px',
							'1603.5635542557284px 982.0643362687675px',
							'1597.7728590471422px 978.1213009547656px',
							'1588.7337250630078px 971.7303507550455px',
							'1565.818108048542px 958.8425230042288px',
							'1565.818108048542px 958.8425230042288px',
							'1558.5209824600925px 954.4524687503681px',
							'1554.0367245851508px 949.8033890200943px',
							'1554.0367245851508px 949.8033890200943px',
							'1545.6684638264012px 941.3410625665026px',
							'1545.6684638264012px 941.3410625665026px',
							'1544.409059340178px 939.9051124946517px',
							'1541.796184672889px 936.998041160063px',
							'1539.736532149313px 935.2796181512078px',
							'1539.736532149313px 935.2796181512078px',
							'1538.0770036444135px 934.2320683677377px',
							'1534.42830292395px 932.3606851600848px',
							'1531.5682644367823px 931.230793412068px',
							'1531.5682644367823px 931.230793412068px',
							'1527.1899339132171px 929.889046961298px',
							'1519.3160007942251px 927.6292634652644px',
							'1508.111286935138px 924.9810796808501px',
							'1508.111286935138px 924.9810796808501px',
							'1507.6405446822107px 924.863428599178px',
							'1505.7808852048533px 924.4986136976271px',
							'1501.3908309509927px 923.498096761578px',
							'1501.3908309509927px 923.498096761578px',
							'1499.1310474549591px 923.1568672468571px',
							'1499.1310474549591px 923.1568672468571px',
							'1496.4475545534192px 922.3211721661402px',
							'1493.622825183377px 921.462029624832px',
							'1493.622825183377px 921.462029624832px',
							'1491.1864961017159px 920.8852220942891px',
							'1486.37259451611px 920.0143558226854px',
							'1486.37259451611px 920.0143558226854px',
							'1486.0783978488103px 919.9084284713089px',
							'1486.0783978488103px 919.9084284713089px',
							'1490.6921684619585px 920.6146108138194px',
							'1501.8732969342157px 921.4973387419575px',
							'1512.6778867746264px 923.0037691218207px',
							'1525.2715178581434px 925.00466506768px',
							'1533.616193230063px 925.6519529062351px',
							'1547.3161306747666px 927.4174087625113px',
							'1557.7559056136265px 927.9823546365197px',
							'1567.2893672375183px 928.4413731591516px',
							'1569.11371759775px 928.4413731591516px',
							'1572.444498337845px 928.5591621670625px',
							'1574.0804414559148px 928.6650895184391px',
							'1575.3515696724337px 928.8063259869411px',
							'1575.6576279962678px 928.8769442211923px',
							'1577.258261997212px 928.8769442211923px',
							'1577.258261997212px 928.8769442211923px',
							'1577.6702476724226px 928.8769442211923px',
							'1577.9880297265524px 928.8769442211923px',
							'1583.1784699440047px 928.8769442211923px',
							'1587.0624728278124px 928.8769442211923px',
							'1591.5231453159242px 928.8769442211923px',
							'1591.5231453159242px 928.8769442211923px',
							'1613.073568419029px 929.2064500056175px',
							'1618.4993107998255px 929.2064500056175px',
							'1618.4993107998255px 929.2064500056175px',
							'1639.578853723764px 929.2064500056175px',
							'1645.110661382176px 929.2064500056175px',
							'1645.110661382176px 929.2064500056175px',
							'1656.7626700335993px 929.889046961298px',
							'1657.1863794391056px 929.889046961298px',
							'1657.4571286458142px 929.889046961298px',
							'1658.634053241252px 929.889046961298px',
							'1660.1523452776496px 929.889046961298px',
							'1661.3411315296219px 929.889046961298px',
							'1661.8824920168004px 929.889046961298px',
							'1662.1179321063835px 929.889046961298px',
							'1662.1413795669746px 929.889046961298px',
							'1662.1413795669746px 929.889046961298px',
							'1662.1413795669746px 930.1127633205856px',
							'1662.1413795669746px 930.3127563668044px',
							'1662.1413795669746px 930.3127563668044px',
							'1662.153241223509px 930.3127563668044px',
							'1662.9887983779872px 931.1484514475214px',
							'1666.2608225403656px 937.8571837013712px',
							'1675.088101821747px 955.0880328586276px',
							'1717.388424138126px 1013.6188253224528px',
							'1792.090792245442px 1111.3072907522467px',
							'1872.513099400854px 1243.4458686924966px',
							'1927.195198097997px 1356.9528185945258px',
							'1966.8826457470873px 1471.8958564946447px',
							'1999.5199937013683px 1588.674968485291px',
							'2016.068245902944px 1664.0715193523442px',
							'2029.144342969684px 1772.2470684208968px',
							'2030.9097988259603px 1840.5936575193791px',
							'2030.9097988259603px 1892.4508889202414px',
							'2029.6033614923158px 1917.6500127438096px',
							'2026.3314752561762px 1939.3532581194734px',
							'2022.6474654185872px 1955.065815240332px',
							'2019.1165537060347px 1966.894369477383px',
							'2012.478439686436px 1984.443000688769px',
							'2006.946769954263px 1996.942428151205px',
							'2000.0143213411257px 2014.9500778852228px',
							'1992.4228611591377px 2037.4419854941823px',
							'1988.3270035725768px 2046.492981134851px',
							'1985.0198082193117px 2051.8009345077367px',
							'1982.4186572823185px 2053.684179371924px',
							'1978.6994762538427px 2055.838035516581px',
							'1972.2496315501671px 2060.004511337393px',
							'1966.5412783061277px 2063.7472777526987px',
							'1956.2546014923043px 2069.7969984376978px',
							'1948.0981954363078px 2072.7982733933673px',
							'1938.8472067494204px 2074.8577879907048px',
							'1936.2460558124271px 2075.4464571777817px',
							'1935.9988919925484px 2075.5170754120327px',
							'1935.7517281726698px 2075.587693646284px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};
